import React from 'react';
import { FormField, FormFieldErrorHelp, FormFieldLabel, FormTextArea } from '@styled/Form';
function TextArea(_a) {
    var label = _a.label, value = _a.value, name = _a.name, onChange = _a.onChange, _b = _a.rows, rows = _b === void 0 ? 4 : _b, css = _a.css, bottomMargin = _a.bottomMargin, invalid = _a.invalid, invalidString = _a.invalidString, _c = _a.disabled, disabled = _c === void 0 ? false : _c;
    var isInvalid = invalidString && invalidString !== '' ? true : false;
    return (React.createElement(FormField, { style: css, "$bottomSpace": bottomMargin },
        React.createElement(FormFieldLabel, null, label),
        React.createElement(FormTextArea, { disabled: disabled, "$invalid": invalid, name: name, value: value, onChange: onChange, rows: rows }),
        isInvalid && React.createElement(FormFieldErrorHelp, null, invalidString)));
}
export default TextArea;
